module.exports = __webpack_public_path__ + "media/images/flags/al-7f7b766868a56e7b70b571292b2954ec.svg";